import { Box, CheckIcon, CloseIcon, makeStyles, Theme } from '@freighthub/silhouette-core'
import { FC, ReactNode } from 'react'
import { formatNumber } from 'service/NumberFormatter'
import { useI18n } from 'utils/localisation'

import { IQuoteSheet } from '../QuoteSheetModel'

type AdditionalServicesProps = {
  quoteSheet: IQuoteSheet
}

const useStyles = makeStyles<Theme>((theme) => ({
  additionalServices: {
    display: 'flex',
    padding: theme.spacing(1, 2, 2),
    flexWrap: 'wrap',
  },
  insurance: {
    fontSize: theme.typography.subtitle2.fontSize,
    color: theme.palette.text.secondary,
    display: 'inline-block',
  },
  icon: {
    width: 18,
    height: 18,
    fontSize: theme.typography.h6.fontSize,
    marginRight: theme.spacing(0.5),
  },
  iconText: {
    fontSize: theme.typography.subtitle2.fontSize,
    display: 'flex',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1),

    '&:last-of-type': {
      marginBottom: 0,
    },
  },
}))

export const AdditionalServices: FC<AdditionalServicesProps> = ({ quoteSheet }) => {
  const { translate } = useI18n()
  const {
    request: { services: quoteSheetServices },
  } = quoteSheet
  const classes = useStyles()

  return (
    <div className={classes.additionalServices}>
      <Box margin={1}>
        <Service
          name={
            <div>
              {translate('quotesheet_header-customs')}
              {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
              {quoteSheetServices.customsSelected && (
                <span>
                  ,&nbsp;
                  {translate('quotesheet_header-num_hscodes', {
                    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
                    count: quoteSheetServices.hsCodesCount,
                  })}
                </span>
              )}
            </div>
          }
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          checked={quoteSheetServices.customsSelected}
        />
      </Box>
      <Box margin={1}>
        <Service
          name={translate('quotesheet_header-insurance')}
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          checked={!!quoteSheetServices.insurances && !!quoteSheetServices.insurances.length}
        />
        {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
        {quoteSheetServices.insurances &&
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          quoteSheetServices.insurances.map((ins, i) => (
            <div className={classes.insurance} key={i}>
              <div>{translate('manual_quote-insurance-commodity_class', { class: ins.commodityClass })}</div>
              <div>{`${formatNumber(Number(ins.value.value))} ${ins.value.code}`}</div>
            </div>
          ))}
      </Box>
      <Box margin={1}>
        <Service
          name={translate('common-buyers_consolidation')}
          // @ts-expect-error TS(2322) FIXME: Type 'boolean | undefined' is not assignable to ty... Remove this comment to see the full error message
          checked={quoteSheetServices.buyersConsolidation && quoteSheetServices.buyersConsolidation.enabled}
        />
      </Box>
      {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
      {quoteSheetServices.dangerousGoods && (
        <Box margin={1}>
          <Service name={translate('common-dangerous_goods')} checked />
        </Box>
      )}
    </div>
  )
}

type ServiceProps = {
  name: ReactNode
  checked: boolean
}

const Service: FC<ServiceProps> = ({ checked, name }) => {
  const classes = useStyles()
  const Icon = checked ? CheckIcon : CloseIcon
  return (
    <div className={classes.iconText}>
      <Icon color="action" className={classes.icon} />
      {name}
    </div>
  )
}
